import { createSlice } from "@reduxjs/toolkit";

const emaillogsSlice = createSlice({
  name: "emaillogs",
  initialState: {
    loading: false,
    error: null,
    emailLogs: [],
    totalCount: 0,
  },
  reducers: {
    getEmailLogs: (state) => {
      state.loading = true;
      state.error = null;
    },
    getEmailLogsSuccess: (state, action) => {
      state.loading = false;
      state.emailLogs = action.payload.data || [];
      state.totalCount = action.payload.total || 0;
    },
    getEmailLogsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getEmailLogs,
  getEmailLogsSuccess,
  getEmailLogsFailure,
} = emaillogsSlice.actions;

export default emaillogsSlice.reducer;
